export const assetStatuses = [
  'USE',
  'REPAIR',
  'DISCARDED',
  'RETURN',
  'BUYOUT',
  'RETURNED',
  'CONTRACTED_EXT',
  'REQ_SENT',
  'STOLEN',
  'LOST',
  'DELIVERY',
  'CANCELLED',
  'AVAILABLE',
  'REMARKETED',
  'SOLD',
] as const

export const assetTypes = [
  'TABLET',
  'SERVER_STORAGE_NETWORK',
  'SCREEN',
  'PC',
  'OTHER',
  'HEADSET',
  'DOCKING',
  'CONTRACT',
  'CAR_CHARGER',
  'BIKE',
  'AV_EQUIPMENT',
  'MOBILE_PHONE',
  'SMART_WATCH',
  'PRINTER',
  'UPS',
] as const

export const userTypes = [
  'AVAILABLE',
  'BUFFERSTOCK',
  'DISCHARGED',
  'EMPLOYEE',
  'GREENPOOL',
  'HOME_OFFICE',
  'POOL',
  'PROJECT',
  'LOCATION',
] as const

export const typeOptions = [
  { value: 'EMAIL', label: 'EMAIL' },
  { value: 'SMS', label: 'SMS' },
  { value: 'SYSTEM', label: 'SYSTEM' },
]

export const ownershipTypes = ['OWNED'] as const
export const returnStatuses = ['NONE', 'FOR_CONTROL', 'RETURNED', 'SELECTED'] as const
export const resultStatuses = ['A', 'B', 'C'] as const

export const leasingAssetActions = {
  LEASE_END: 'LEASE_END',
  RETURN: 'RETURN',
  EMPLOYEE_SELECTION: 'EMPLOYEE_SELECTION',
  EXTENSION: 'EXTENSION', // 3_MONTH_EXTENSION, 6_MONTH_EXTENSION, 9_MONTH_EXTENSION, 12_MONTH_EXTENSION as number of months
  BUYOUT: 'BUYOUT', // TODO: implement buyout action
}
